import React from 'react';
import PublicLayout from './PublicLayout';

const OPEN_ROLES = [
  { team: 'Engineering', title: 'Senior Full-Stack Engineer', location: 'Remote (US)', type: 'Full-time' },
  { team: 'Engineering', title: 'Mobile Engineer (React Native)', location: 'Remote (US)', type: 'Full-time' },
  { team: 'Product', title: 'Product Manager — Worker Experience', location: 'NYC or Remote', type: 'Full-time' },
  { team: 'Customer Success', title: 'Implementation Manager (Healthcare)', location: 'Remote (US)', type: 'Full-time' },
];

export default function CareersPage() {
  return (
    <PublicLayout title="Join the team" eyebrow="Careers">
      <p className="lead">We're a small, distributed team building infrastructure for a regulated, life-critical industry. If you care about reliability, accessibility, and shipping software that real workers depend on for their next paycheck, we want to talk.</p>
      <h2>Open roles</h2>
      <div className="not-prose grid gap-3 my-6">
        {OPEN_ROLES.map((r, i) => (
          <div key={`${r.team}-${i}`} className="bg-white border border-slate-200 rounded-xl p-5 flex items-center justify-between" data-testid={`careers-role-${i}`}>
            <div>
              <p className="text-xs uppercase tracking-wider text-violet-600 font-semibold">{r.team}</p>
              <h3 className="text-lg font-semibold text-slate-900 mt-1">{r.title}</h3>
              <p className="text-sm text-slate-500 mt-1">{r.location} · {r.type}</p>
            </div>
            <a href="mailto:careers@scensobconnect.com" className="px-4 py-2 bg-violet-600 hover:bg-violet-700 text-white text-sm font-semibold rounded-lg">Apply</a>
          </div>
        ))}
      </div>
      <h2>Our principles</h2>
      <ul>
        <li><strong>Reliability is a feature.</strong> A worker checking in at 6am can't wait for "rolling deploys."</li>
        <li><strong>Accessibility is non-negotiable.</strong> We build to WCAG AA, screen reader first.</li>
        <li><strong>Boring tech wins.</strong> Postgres-style discipline on a Mongo stack. Mature libraries over bleeding-edge ones.</li>
      </ul>
      <p>Don't see your role? Email <a href="mailto:careers@scensobconnect.com">careers@scensobconnect.com</a> with what you'd build here.</p>
    </PublicLayout>
  );
}
